import { recipeDetailData } from "@/utils/aemDefaultData";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";
import { Toast, Box, Text } from "@dxp-feed/ui";
import Link from "next/link";

const ToastMessage = () => {
  const { message, messageOf, status, color } = useAppSelector(
    (state) => state.toastMessageSlice
  );
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );
  const dispatch = useAppDispatch();
  /** Close Toast Message */
  const handleClose = () => {
    dispatch(setToastMessage({ message: "", status: "" }));
  };


  const renderViewList = () => {
    const shouldRenderRecipeLink =
      messageOf === "recipe" && !["favouriteMessage", "other"].includes(status);

    const shouldRenderMealLink =
      messageOf === "meal" && ["mealError", "mealSuccess"].includes(status);

    if (shouldRenderRecipeLink) {
      return (
        <Link
          href="/recipes/my-recipe-lists"
          className="ml-[38px] font-bold text-primary600 underline"
        >
          {aemModalData?.viewListTitle}
        </Link>
      );
    }

    if (shouldRenderMealLink) {
      return (
        <Link
          href="/recipes/meal-plan"
          className="ml-[38px] font-bold text-oliveGreen underline"
        >
          {aemModalData?.viewMealPlan ?? recipeDetailData[0]?.viewMealPlan}
        </Link>
      );
    }

    return null;
  };

  return (
    <>
      {message?.length ? (
        <Toast
          message={
            <Box as="div" className="text-[14px]">
              {message}
              {renderViewList()}
            </Box>
          }
          bgColor={color ?? "success"}
          position="top"
          onClose={handleClose}
          closeButton={
            <Text as="span" className="demo-icon icon-close text-[14px]"></Text>
          }
          className="font-normal flex w-[90%] md:w-[600px] lg:w-auto z-[999990]"
        />
      ) : null}
    </>
  );
};

export default ToastMessage;
